<template>
<div v-if="thread">
  <template v-if="error">{{error}}</template>
  <template v-else>
    <vue-headful :title="htmlDecode(thread.title) + ' — ' + site_title" />
    <Header :breadcrumbs="bread" />

    <!-- pages widget -->
    <ThreadPages :totalItems="thread.numPosts" :prependIntoLink="'index.php?act=ST&t='+getThreadId()" :itemsPerPage="40" />

    <!-- thread main div -->
    <div class="forums">

      <!-- thread title and subtitle -->
      <div class="forum__section_title forum__thread_title">
        <img class="thread_title_icon thread__align_middle" src="../assets/nav_m.gif" />
        <span class="thread__align_middle">
          <b>{{htmlDecode(thread.title)}}</b>
          <template v-if="thread.description.length > 0">,</template>
          {{htmlDecode(thread.description)}}
        </span>
      </div>

      <!-- poll here (optional) -->
      <template v-if="thread.poll && thread.poll.choices && thread.poll.choices.length > 0">
        <div class="forum__thread_subtitle thread_poll_title">
          {{htmlDecode(thread.poll.poll_question)}}
        </div>
        <table cellspacing="1" class="thread__poll_table">
          <tbody>
            <tr v-for="(pollChoice, index) in thread.poll.choices">
              <td width="30%" :class="{thread__poll_first_entry: index === 0}" class="thread_poll_first_column">{{htmlDecode(pollChoice.choice)}}</td>
              <td width="3%" :class="{thread__poll_first_entry: index === 0}" class="thread__poll_middle">[ <b>{{htmlDecode(pollChoice.votes)}}</b> ]</td>
              <td width="30%" :class="{thread__poll_first_entry: index === 0}" class="thread__poll_third_column">
                <img src="../assets/bar_left.gif" />
                <img src="../assets/bar.gif" :width="pollChoice.votes / thread.poll.votes * 400" height="11" />
                <img src="../assets/bar_right.gif" />
                [{{parseFloat(pollChoice.votes / thread.poll.votes * 100).toFixed(2)}}%]
              </td>
            </tr>
            <tr>
              <td colspan="3" class="thread__poll_middle">Всего голосов: {{thread.poll.votes}}</td>
            </tr>
          </tbody>
        </table>
      </template>
      <!-- end of poll -->

      <div class="forum__thread_subtitle">
        <span>
          « <a>К предыдущей</a> | <a>К следующей</a> »
        </span>
        <div style="float: right;">
          <a>Подписаться на тему</a> | <a>Послать эту тему</a> | <a>Распечатать тему</a>
        </div>
      </div>
      <!-- end of thread title -->

      <!-- foreach post -->
      <template v-for="(post, index) in thread.posts">
        <table v-bind:class="{'thread_end_decorator_bottomless': index < thread.posts.length-1}" cellspacing="1">
          <tbody>
            <!-- row: poster name, date, post number -->
            <tr class="forum__thread_row_top">
              <td class="thread__nickname" width="1%" align="center">
                <template v-if="post.author_id != 0">
                  <template v-if="post.author_id == 10"><img src="../assets/vave_name.gif" alt="ВэйВ[LFL]"></template>
                  <template v-else>
                    <b><a class="post__postername" :href="'index.php?showuser='+post.author_id">{{htmlDecode(post.name)}}</a></b>
                  </template>
                </template>
                <template v-else>
                  {{htmlDecode(post.name) + ' '}}
                </template>
              </td>
              <td width="99%" valign="top">
                <!-- POSTED DATE DIV -->
                <div class="thread__post_date_flex">
                  <div>
                    <b>Оставлен:</b> {{post.post_date | formatDate}}
                  </div>
                  <div class="last_elem">
                    <a :id="post.pid" title="Ссылка этого сообщения" :href="'#' + post.pid">#{{index+1+skipThreads}}</a>
                  </div>
                </div>
              </td>
            </tr>

            <!-- row: avatar, post, etc -->
            <tr v-bind:class="{forum__thread_row_mid: true, forum__post_odd: index % 2 == 1}">
              <!-- AVATAR, etc... -->
              <td class="post_left_side" valign="top" align="center">
                <!-- AVATAR -->
                <template v-if="post.avatar !== null && post.avatar.length > 0 && post.avatar !== 'noavatar'">
                  <img :src="fixAvatarPath(post.avatar)" />
                </template>
                <br>
                <!-- title -->
                <span class="poster__title">
                  <template v-if="post.warn_level >= 5">
                    <font color="red">Арестант</font>
                  </template>
                  <template v-else>
                    <span style="font-size: 11px;" v-html="post.title" />
                  </template>
                </span>
                <br>
                <!-- PIPS -->
                <div class="poster__pips">
                  <template v-if="post.author_id == 10 || post.author_id == 30">
                    <img src="../assets/vave_pips.gif" />
                  </template>
                  <template v-else-if="post.author_id == 687">
                    <img style="padding-top: 2px;" src="../assets/exdeath_pips.gif" />
                  </template>
                  <template v-else v-for="n in post.pips">
                    <img src="../assets/star.gif" alt="*">
                    <template v-if="n < post.pips"><span v-html="nbsp"></span></template>
                  </template>
                </div>

                <div class="poster_info" v-bind:class="{vave_info: post.author_id == 10 || post.author_id == 30}">
                  <!-- joined -->
                  <template v-if="post.author_id > -1">
                    <div v-bind:class="{vave_joined: post.author_id == 10 || post.author_id == 30}">
                      <template v-if="post.author_id == 10">Вступил: 7 Января, 0 года<br></template>
                      <template v-else>
                        Вступил<template v-if="post.gender == 'f'">а</template>: {{post.joined | formatDateShort}}<br>
                      </template>
                    </div>
                  </template>
                  <!-- Posts -->
                  <font color="#00cc00">
                    <template v-if="post.author_id == 10">
                      Опыт: Лимит<br>
                    </template>
                    <template v-else-if="post.author_id > -1">
                      Опыт: {{post.posts}} XP<br>
                    </template>
                  </font>
                  <!-- Gold -->
                  <template v-if="post.author_id > -1">
                    <font color="#ffcc33">Золото: {{post.author_id === 10 ? '&infin;' : post.gold}}</font><br> <!-- VaVe special case: infinite gold -->
                  </template>
                  <!-- special for Vave -->
                  <template v-if="post.author_id == 10">
                    План: <a><u>Mount Celestia</u></a><br>
                    <font color="#ff3333"><u>Награды: Много</u></font><br>
                  </template>
                  <!-- awards -->
                  <template v-if="post.awards > 0">
                    <!-- TODO: popup 600x300 window -->
                    <a @click.prevent="openAwardsPopup(post.author_id)" class="forum__thread_awards" :href="'index.php?act=Awards&id=' + post.author_id">Награды: {{post.awards}}</a><br>
                  </template>
                  <!-- alignment -->
                  <template v-if="post.author_id > -1">
                    <a @click.prevent="openRatingsPopup(post.author_id)" :href="'index.php?act=Rate&id='+post.author_id"><u>
                        Характер<template v-if="post.alignment !== null && post.alignment.length > 0">: {{post.alignment | formatAlignment}}</template>
                      </u></a><br>
                  </template>
                  <!-- warnings -->
                  <template v-if="post.warn_level && post.warn_level > 0">
                    Предупреждений: {{post.warn_level}}<br>
                  </template>
                </div>
                <div style="width: 160px; height: 10px;"></div>
              </td>
              <!-- POST -->
              <td class="post_right_side" width="100%" valign="top">
                <!-- THE POST -->
                <div v-html="fixVariousTags(fixNewsTags(fixRpgplanetLinks(fixRealmsMainPaths(fixSmileysPath(post.post))), post))"></div>

                <!-- edited by... Сообщение отредактировал virus_found - 29 September 2004, 00:42  -->
                <div v-if="post.append_edit" class="thread__edit_by">
                  <br>
                  Этот пост отредактировал <b>{{htmlDecode(post.edit_name)}}</b> - {{post.edit_time | formatDate}}
                </div>
                <br>
                <br>

                <!-- Signature -->
                <div v-if="post.use_sig && post.signature && post.signature.length > 0">
                  --------------------
                  <br>
                  <div v-html="fixVariousTags(fixRpgplanetLinks(post.signature))"></div>
                </div>
              </td>
            </tr>

            <!-- row: buttons like PM, quote, reply, etc... -->
            <tr class="forum__thread_row_bottom">
              <td></td>
              <td>
                <!--  PM / EMAIL / WWW / MSGR  -->
                <div style="float:left;">
                  <!--<img src="../assets/p_up.gif" @click="goToTop()" style="cursor: pointer;" /> -->
                  <template v-if="post.author_id != 0">
                    <a :href="'index.php?act=PROFILE&MID=' + post.author_id"><img src="../assets/p_card.gif" /></a><span v-html="nbsp"></span>
                  </template>
                  <template v-else>
                    <a><img src="../assets/p_card.gif" /></a><span v-html="nbsp"></span>
                  </template>
                  <template v-if="post.hide_email !== null && post.hide_email == 0">
                    <a><img src="../assets/p_email.gif" /></a><span v-html="nbsp"></span>
                  </template>
                  <a><img src="../assets/p_pm.gif" /></a><span v-html="nbsp"></span>
                  <template v-if="post.website && post.website.length > 0 && post.website !== 'http://'">
                    <a :href="post.website"><img src="../assets/p_www.gif" /></a><span v-html="nbsp"></span>
                  </template>
                  <img v-if="post.icq_number" src="../assets/p_icq.gif" />
                </div>
                <!-- QUOTE / REPLY -->
                <div align="right">
                  <!--
                <a title="Добавить к многочисленным цитатам">
                  <img src="../assets/p_mq_add.gif" />
                </a>
              -->
                  <a>
                    <img src="../assets/p_quote.gif" />
                  </a>
                </div>
              </td>
            </tr>

            <!-- row: decorative separator -->
            <tr>
              <td v-bind:class="{'thread__end_decorator': true, 'thread_end_decorator_bottomless': index < thread.posts.length-1}" colspan="2"></td>
            </tr>

          </tbody>
        </table>
      </template>

      <!-- end of foreach post -->


    </div> <!-- end of <div class="forums"> -->

    <!-- pages again -->
    <ThreadPages :totalItems="thread.numPosts" :prependIntoLink="'index.php?act=ST&t='+this.$route.query.t" :itemsPerPage="40" />
</template> <!-- v-else (if no error)-->
<FooterPermanent v-if="this.footerReady" :loadTime="this.loadTime" :totalRequests="this.queries" />
</div>
</template>

<script>
import Header from './Header'
import ThreadPages from './ThreadPages'
import FooterPermanent from './FooterPermanent'
import {
  globalFormatDate,
  globalRusDate
} from '../../public/utils.js';

export default {
  components: {
    Header,
    ThreadPages,
    FooterPermanent
  },
  data: function() {
    return {
      thread: null,
      bread: null,
      skipThreads: 0,
      error: null,
      footerReady: false
    }
  },
  async created() {
    console.time("PageLoadTime");
    let response = null;
    let dateEarly = new Date();
    let pagenumber = 0;
    if (this.$route.query.st) {
      pagenumber = Number(this.$route.query.st);
      if (!pagenumber)
        pagenumber = 0;
    }

    let threadNumber = 0;
    if (this.$route.query.t) {
      threadNumber = this.$route.query.t.replace(/\D/g, ''); // strip non-numeric characters
    } else {
      threadNumber = this.$route.query.showtopic;
    }
    threadNumber = Number(threadNumber);
    if (!threadNumber)
      threadNumber = 0;

    response = await fetch(this.getNodePath() + 'thread/' + threadNumber + '/page/' + pagenumber);
    let dateLater = new Date();
    let data = await response.json();
    this.thread = data;
    if (data.error) {
      this.error = data.error;
    } else {
      this.queries = data.queries;
      this.bread = data.bread;
      this.skipThreads = pagenumber;
      this.loadTime = this.spanSeconds(dateEarly, dateLater);
      this.footerReady = true;
    }
    //console.log(data);
    console.timeEnd("PageLoadTime");

    // if we have a link ending with e.g. #1234 (post number) or #entry1234
    if (location.hash) {
      this.$nextTick(() => {
        let pureNumber = location.hash.replace('entry', '');
        const postId = pureNumber.substring(1);
        const element = document.getElementById(postId);
        element.scrollIntoView();
      });
    }
  },
  methods: {
    openRatingsPopup(memberId) {
      let myWindow = window.open("/index.php?act=Rate&id=" + memberId, "Rating", "width=800,height=650");
    },
    openAwardsPopup(memberId) {
      let myWindow = window.open("/index.php?act=Awards&id=" + memberId, "Awards", "width=850,height=650");
    },
    fixSmileysPath(postText) {
      // in a link like <img src='http://forums.realms.ru/html//emoticons/yes.gif'
      // 1- replace forums.realms.ru or realms.ru with /
      // 2- replace html// with html/
      // also replaces 'upload/html' to 'html'
      return postText.replace(/(<img src|a href)=("|')(?:http|https)(?::\/\/)(www\.)?(forums\.)?(realms\.ru)(\/upload)?(\/html\/\/)?/g, function(a, b, c) {
        return a.replace(/http:\/\//, '').replace(/www\./, '').replace(/forums\.realms\.ru/, '').replace(/realms\.ru/, '').replace(/\/upload/, '').replace(/html\/\//, 'html/')
      }).replace(/(<img src|a href)=("|')(?:http|https)(?::\/\/)(forums\.)?(rpgplanet\.ru)(\/html\/\/)?/g, function(a, b, c) {
        return a.replace(/http:\/\//, '').replace(/www\./, '').replace(/forums\.rpgplanet\.ru/, '').replace(/rpgplanet\.ru/, '').replace(/html\/\//, 'html/')
      });
    },
    fixNewsTags(newsPost, post) { // only affects OP posts
      if (!post.new_topic)
        return newsPost;
      // strip [preview] and [/preview] tags
      return newsPost.replace(/\[preview\](.+?)\[\/preview\]/gi, "$1");
    },
    fixRpgplanetLinks(html) {
      // oldforums.rpgplanet.ru to /oldforums/, examples: http://localhost:8080/index.php?showtopic=221#2995
      // steelworld.rpgplanet.ru/forums/ to local url
      // etc,.. many such cases.
      // eg. http://localhost:8080/index.php?showtopic=3603 , http://localhost:8080/index.php?showtopic=192&st=268
      return html.replace(/<a href=("|')http:\/\/((www|forums)\.){0,2}((.{0,15}?)\.){0,1}?(rpgplanet|realms)\.ru(\/forums)?/gu, function(a, b, c, d, e, f) {
          let result = '';
          if (f) {
            result = `<a href=${b}/${f}`;
          } else {
            result = `<a href=${b}`;
          }
          return result;
        })
        // img src="http://www.rpgplanet.ru/forums" (and without forums) to local website url
        .replace(/<img src="http:\/\/www\.rpgplanet\.ru(\/forums){0,1}/g, function(a, b) {
          return a.replace("http://www.rpgplanet.ru/forums", "").replace("http://www.rpgplanet.ru", "");
        });
    },
    goToTop() {
      scroll(0, 0);
    },
    fixVariousTags(html) {
      // Finds [mergetime]1232312[/mergetime], turns it into date
      return html.replace(/\[mergetime\](\d+)\[\/mergetime\]/g, function(a, b) {
          return globalFormatDate(b);
        })
        // changes [hide]text[/hide] to <i>text</i> - hide tag was used to hide info from unregistered users only
        .replace(/\[hide\](.*?)\[\/hide\]/gi, "<i>$1</i>")
        // change [topic=123]text[/topic] to <a href="index.php?showtopic=123">text</a>
        .replace(/\[topic=([0-9]+)\](.+?)\[\/topic\]/gi, "<a href=\"/index.php?act=ST&t=$1\">$2</a>")
        // same with [user]
        .replace(/\[user=([0-9]+)\](.+?)\[\/user\]/gi, "<a href=\"/index.php?act=Profile&MID=$1\">$2</a>")
        // same with [forum]
        .replace(/\[forum=([0-9]+)\](.+?)\[\/forum\]/gi, "<a href=\"/index.php?act=SF&f=$1\">$2</a>")
        // same with [post]
        .replace(/\[post=([0-9]+)\](.+?)\[\/post\]/gi, "<a href=\"/index.php?view=findpost&p=$1\">$2</a>")
        // [hl] tag gives text a different color
        .replace(/\[hl\](.+?)\[\/hl\]/gi, "<span class=\"thread__hl\">$1</span>")
        .replace(/\[quotetime\](\d+)\[\/quotetime\]/g, function(a, b) {
          return globalRusDate(b);
        });
    },
    getThreadId() {
      let threadNumber = 0;
      if (this.$route.query.t) {
        threadNumber = this.$route.query.t; // strip non-numeric characters
      } else {
        threadNumber = this.$route.query.showtopic;
      }
      return threadNumber;
    }
  }
}
</script>

<style lang="scss">
@import "../skin-blue.scss";
@import "./Thread.scss";
</style>
